import { isNationalDayWindowActive } from "@/components/auth/national-day-theme";
import { cn } from "@/lib/utils";
import { Poppins } from "next/font/google";
import Image from "next/image";
import { FC } from "react";

const font = Poppins({
  subsets: ["latin"],
  weight: ["600"],
});

interface HeaderProps {
  label: string;
  logo?: boolean;
}

export const Header: FC<HeaderProps> = ({ label, logo }) => {
  return (
    <div className="w-full flex flex-col gap-y-4 items-center justify-center">
      {/* <h1 className={cn("text-3xl font-semibold", font.className)}>🔐 Auth</h1> */}
      {logo && (
        <Image
          src="/alwasail-logo.png"
          height={50}
          width={270}
          className="w-auto mt-2"
          style={{ maxWidth: "270px" }}
          alt="Alwasail logo"
          priority
        />
      )}
      {/* Saudi National Day theming (time-boxed, see
          components/auth/national-day-theme.tsx): "put under logo of
          alwasail the [badge]", engineer request 2026-09-21. Processed
          with sharp (losslessly re-encoded, EXIF/ICC metadata stripped,
          18.5KB -> 4.8KB with no visible quality loss) before landing in
          the repo. */}
      {logo && isNationalDayWindowActive() && (
        <Image
          src="/images/events/national-day-badge.png"
          height={30}
          width={104}
          className="w-auto"
          style={{ maxWidth: "140px" }}
          alt=""
          aria-hidden="true"
        />
      )}
      <p className={cn("text-muted-foreground",logo ? "text-sm":"text-2xl font-bold font-lg underline text-gray-800 uppercase")}>{label}</p>
    </div>
  );
};
